var map = {
	"./program-circle-renewed-en.svg": 94409,
	"./program-circle-renewed-pl.svg": 12052,
	"./program-circle-rental-en.svg": 59716,
	"./program-circle-rental-pl.svg": 80984,
	"./program-circle-repaired-en.svg": 18064,
	"./program-circle-repaired-pl.svg": 65698,
	"./program-circle-revived-en.svg": 61930,
	"./program-circle-revived-pl.svg": 70334,
	"./program-circle-upcycled-en.svg": 9770,
	"./program-circle-upcycled-pl.svg": 74509
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15890;